export default "__VITE_ASSET__BWZ99iU5__"